import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import { List } from 'immutable';
var generateStyle = function generateStyle(componentTheme, props) {
  var mq = "@media screen and (".concat(componentTheme.phoneBreakPoint, ")");
  var mp = '@media print';
  var ms = '@supports (-ms-imeAlign: auto)';
  var stimulus = props.sessionItem.stimulusRecord;
  var stimulusItems = props.isOqaat ? List([props.sessionItem]) : props.sessionItem.getNestedEntries();
  var shouldSetHorizontalOrientation = stimulus.orientation == 'left' || !props.stimulusOrientationEnabled;
  var itemSizeGtOne = stimulusItems.size > 1;
  return {
    root: {
      borderBottom: "".concat(componentTheme.rootBorderWidth, " solid ").concat(componentTheme.rootBorderColor)
    },
    instructions: _defineProperty({
      padding: "".concat(componentTheme.instructionsPaddingTopBottom, " ").concat(componentTheme.instructionsPaddingLeftRight),
      border: "".concat(componentTheme.instructionsBorderWidth, " solid ").concat(componentTheme.instructionsBorderColor)
    }, mq, {
      padding: "".concat(componentTheme.phoneInstructionsPaddingTopBottom, " ").concat(componentTheme.phoneInstructionsPaddingLeftRight)
    }),
    instructionsHeader: {
      paddingBottom: componentTheme.instructionsHeaderPadding,
      fontWeight: componentTheme.instructionsHeaderFontWeight
    },
    items: _objectSpread(_objectSpread(_objectSpread({
      padding: componentTheme.itemsPadding,
      overflow: 'auto'
    }, shouldSetHorizontalOrientation && {
      width: '50%'
    }), itemSizeGtOne && _defineProperty(_defineProperty(_defineProperty({
      maxHeight: '90vh'
    }, ms, {
      overflowX: 'inherit'
    }), mq, {
      width: '100%'
    }), mp, {
      maxHeight: 'none'
    })), {}, _defineProperty({}, mq, {
      width: '100%'
    })),
    stimulusGroup: _objectSpread({}, shouldSetHorizontalOrientation && _defineProperty({
      display: 'flex',
      flexDirection: 'row'
    }, mq, {
      flexDirection: 'column'
    })),
    stimulusInfo: _objectSpread(_objectSpread({
      maxHeight: '90vh',
      overflow: 'auto',
      height: '100%'
    }, shouldSetHorizontalOrientation && {
      width: '50%'
    }), {}, _defineProperty(_defineProperty({}, mq, {
      width: '100%',
      maxHeight: 'auto'
    }), mp, {
      maxHeight: 'none'
    }))
  };
};
export default generateStyle;